export default "skymp5-front/e46548902bb5d694611c3b922422a6c0.jpg";